// extracted by mini-css-extract-plugin
module.exports = {"formControl":"SearchBox__formControl--3WIke"};